"use strict";

class WorldHomeController  {

    constructor() {
        //Este es para cuando pediamos un getChallengeInfo
        this.challenge = new Challenge();
        this.friends = new Array();
        this.challengeRequest = new Object();

        var that =  this;

        $(document).off('keyup','#challengeSearchInput');
        $(document).on('keyup','#challengeSearchInput', function(e) {
            
            if (e.keyCode == 13) {
                api.getFriends(world.token, true,$(this).val());
            }

        });
        $(document).on("click", '#homeRankingButton', function() {
            $( "#rankingTab" ).trigger( "click" );
        });
        $(document).on("click", '#playerImg', function(e) {
            if($(document).find('.profileScreen').length === 0) {
                ga('send', 'event', analytics.GA_CATEGORY_PROFILE, analytics.GA_CATEGORY_PROFILE_EVENT_ACCESS, 'HOME');
                api.getUserProfile(world.token, user.user_world_id);
            }
            e.stopPropagation();
        });

        $(document).on("click", '#playBtn', function() {
            if (world.isClosed()) {
                WorldHomeController.showWorldClosedAlert();
                return false;
            }
            if (!world.isFinishedOrExpired()) {

                ga('send', 'event', analytics.GA_CATEGORY_PLAY, analytics.GA_CATEGORY_PLAY_EVENT_PLAY, user.user_world_id);

                if (!world.can_select_category) {
                    api.createNewGame(world.token, 0);
                    return false;
                }

                api.getnewGameCategories(world.token, null, 'SINGLEGAME');

            }
        });

        $(document).on('click', '#home-my-knowledge', function() {
            myKnowledgeFullModalController.draw();
        });

        $(document).on('click', '#myLevelBtn', function() {
            if (world.world_mode === 'ASSESSMENT') {
                api.getWorldLevels(world.token);
            } else {
                myLevelFullModalController.draw();
            }
        });

        $(document).on("click", '#challengeBtn', function() {


            if (user.isSupervisor()) {

                WorldHomeController.showSupervisorAccessDeniedAlert();

            } else if (world.isClosed()) {

                WorldHomeController.showWorldClosedAlert();

            } else if (!world.isFinishedOrExpired()) {

                ga('send', 'event', analytics.GA_CATEGORY_PLAY, analytics.GA_CATEGORY_PLAY_EVENT_CHALLENGE,user.user_world_id);

                api.getFriends(world.token,true,null);

            }


        });

        $(document).on("click", '.friend-item.is-challenge', function() {
            that.onClickUserChallenge($(this).data("user"));
        });

        $(document).on("click", '.friendsChallengeBtn', function() {

            if (user.isSupervisor()) {

                WorldHomeController.showSupervisorAccessDeniedAlert();
                return false;

            } else if (world.isClosed()) {

                WorldHomeController.showWorldClosedAlert();
                return false;

            } else if (!world.isFinishedOrExpired()) {

                var userWorldId = $(this).attr('data-userid');
                that.setChallengeRequest(null,null,userWorldId,null);

                if(!world.can_select_category){
                    that.setChallengeRequest(null,'0',null,null);
                    chooseBetFullModalController.draw();
                }
                else{
                    api.getnewGameCategories(world.token,null,'CHALLENGE');
                }
                ga('send', 'event', analytics.GA_CATEGORY_PLAY, analytics.GA_CATEGORY_PLAY_EVENT_NEW_CHALLENGE_FROM_FRIENDS,'MENU');

                return false;

            }

        });

        $(document).on("click", '.challengerUserBtn', function() {

            var userWorldId  = $(this).attr('data-worlduser');
            that.setChallengeRequest(null,null,userWorldId,null);

            if(!world.can_select_category){
                that.setChallengeRequest(null,'0',null,null);
                chooseBetFullModalController.draw();
                ga('send', 'pageview', analytics.GA_SCREEN_SELECT_POINTS);
            }
            else{
                api.getnewGameCategories(world.token,null,'CHALLENGE');
            }

        });

        $(document).on("click", '#singleMenuBackLink', function() {
            var context,template;
            var action = $(this).attr('data-back');
            baseController.stackableOrder-- ;

            if (action == 'PREVIOUS') {
                baseController.closeSimpleMenu();
            }

            if(action == 'FRIENDS'){api.getFriends(world.token,false,null);}
            if(action == 'worldHome'){
                api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
            }
            if(action == 'QUIZFIT'){api.getQuestionStats(world.token,true);}

            if(action == 'triggerChallengeBtn'){
                template=Handlebars.compile($("#singleMenuScreen").html());
                context = {text: 'TR_'+baseController.stackableOrder+'_OPONENTE',backAction:'worldHome'};
                $("#baseMenuDiv").html(template(context));
                api.getFriends(world.token,true,null);
            }
            if(action == 'worldCategories'){
                template=Handlebars.compile($("#singleMenuScreen").html());
                context = {text: 'TR_'+baseController.stackableOrder+'_CATEGORIA',backAction:'worldHome'};
                baseController.stackSimpleMenu(context);
                api.getnewGameCategories(world.token,null,'CHALLENGE');
            }

            if(action == 'closeCategory'){
                baseController.closeSimpleMenu();
            }
        });

        //Imagenes de perfil de la pantalla de amigos
        $(document).on("click", '.friendsProfileBtn', function() {
            var userWorldId = $(this).closest('.friendsProfileBtn').attr('data-userid');
            ga('send', 'event', analytics.GA_CATEGORY_PROFILE, analytics.GA_CATEGORY_PROFILE_EVENT_ACCESS,'FRIENDS');
            api.getUserProfile(world.token,userWorldId);
            return false;
        });

        $(document).on('click', '#details-user-completion', function () {
            if(!world.level_completion)
                userCompletionFullModalController.draw();
        });

        $(document).on('click', '#go-to-ranking',function () {
            let tabs = new Tabs;
            let tabId = _.filter(world.world_tabs, ['id', tabs.RANKING_TAB])[0];
            if(!tabId) return;

            if(world?.mode === 'newLayout') {
                window.location.href = '/#/ranking';

                return;
            }

            baseController.tabAction(tabs.RANKING_TAB);
        });
    };

    onClickUserChallenge(userWorldId) {

        const isCurrentUser = userWorldId=== user.user_world_id;

        if (user.isSupervisor()) {

            WorldHomeController.showSupervisorAccessDeniedAlert();
            return false;

        } else if (world.isClosed()) {

            WorldHomeController.showWorldClosedAlert();
            return false;

        } else if (!world.isFinishedOrExpired() && !isCurrentUser) {

            this.setChallengeRequest(null,null,userWorldId,null);

            if(!world.can_select_category){
                this.setChallengeRequest(null,'0',null,null);
                chooseBetFullModalController.draw();
            }
            else{
                api.getnewGameCategories(world.token,null,'CHALLENGE');
            }
            ga('send', 'event', analytics.GA_CATEGORY_PLAY, analytics.GA_CATEGORY_PLAY_EVENT_NEW_CHALLENGE_FROM_FRIENDS,'MENU');

            return false;

        }
    }

    createChallenge(challengeOponent,action,game_id,isSourcePlayer,isChallengeNotification){

        var challengeCategory = new Object();
        var challengeStars;
        var that = this;

        //$("#baseMenuDiv").hide();

        if(this.challengeRequest.category_id == 0){
            //es aleatoria. Sacamos los de mundo
            challengeCategory.color = world.theme.base_color;
            challengeCategory.dark_color = world.theme.base_dark_color;
        }
        else{
            //Tengo el listado de categorias
            if(action == 'CREATE-CHALLENGE' ){
                $.each(world.categories, function( key, obj ) {
                    if(obj.category.id == that.challengeRequest.category_id ){
                        challengeCategory.color = obj.category.color;
                        challengeCategory.dark_color = obj.category.dark_color;
                    }
                });
            }
            else{
                //Tengo el objeto Challenge creado
                challengeCategory.color = this.challenge.game.category.color;
                challengeCategory.dark_color = this.challenge.game.category.dark_color;
            }
        }
        //Numero de estrellas
        challengeStars =  this.challengeRequest.bet_stars;

        //Buscar el oponente si no lo tenemos

        if(!challengeOponent){

            var request = new Object();
            request.world_token = world?.token;
            request.user_world_id = that.challengeRequest.challenge_user_id;
            request = JSON.stringify(request);

            $.ajax({
                type: "POST",
                url: Routing.generate('basic_profile'),
                data: request,
                beforeSend: function(jqXHR,settings){
                    settings.data = api.addAccessToken(settings);
                    api.sendHeader(jqXHR,true)
                },
                success:  function (response) {
                    if(api.checkisValidResult(response)){
                        var result = response.result;
                        that.allChallengeData(challengeCategory,result.user,challengeStars,action,game_id,isSourcePlayer,isChallengeNotification);
                    }
                }
            })
        }
        else{
            that.allChallengeData(challengeCategory,challengeOponent,challengeStars,action,game_id,isSourcePlayer,isChallengeNotification);
        }

    };

    allChallengeData(challengeCategory,challengeOponent,challengeStars,action,game_id,isSourcePlayer=true,isChallengeNotification=false){

        if (isChallengeNotification) {
            if(action == 'CONFIRM-CHALLENGE' || action == 'CONFIRM_CHALLENGE' ){
                api.confirmChallenge(world.token, game_id);
            }
            return;
        }

        var points = '';
        $.each(world.game_bets, function( key, game_bet ) {
            if(game_bet.game_bet.stars == challengeStars ) {
                points = game_bet.game_bet.points;
            }
        });
        
        var context = {
            world: world,
            game: {
                category: challengeCategory,
                user: user,
                opponent: challengeOponent,
                stars: challengeStars,
                points: points
            },
            isSourcePlayer: isSourcePlayer,
            starIcon: customIcons["BET_ICON"]
        };
        var template = Handlebars.compile($("#newChallengeModal").html());

        api.getChartToken(function (responseToken) {
            context.token = responseToken.token;
            $("#modalContainer").html(template(context)).modal('show');
        })

        var that = this;
        $(document).one('click', '.modal-close-btn, .modal-accept-btn', function () {

            $("#modalContainer").modal('hide').empty();
            $(document).off('click', '.modal-close-btn, .modal-accept-btn');

            if(action == 'CONFIRM-CHALLENGE' || action == 'CONFIRM_CHALLENGE' ){
                api.confirmChallenge(world.token, game_id);
            }

            if(action == 'CREATE-CHALLENGE'){
                that.challengeRequest.world_token = world.token;
                api.createNewChallenge(that.challengeRequest, challengeOponent);
            }

            if(action == 'REVENGE_CHALLENGE'){
                api.cloneChallenge(world.token, game_id);
            }

        });

    }

    setChallengeRequest(token,category_id,challenge_user_id,bet_stars){

        if (token) { this.challengeRequest.world_token = token;}
        if (category_id) { this.challengeRequest.category_id = category_id;}
        if (challenge_user_id) { this.challengeRequest.challenge_user_id = challenge_user_id;}
        if (bet_stars) { this.challengeRequest.bet_stars = bet_stars;}


    };

    draw(theme,user,showHelpModal){
        $('#progressBar').css('width',user.level.progress*100 +'%');
        $('#playerImg').css('background-image','url(' +  user.icon + ')');
        if(user.isSupervisor()){
            if($('.supervisorBadge').length == 0){
                var badgeSupervisor = $('<img>', {
                    'class': 'img-responsive supervisorBadge',
                    'src': '/images/banner_supervisor.png'
                });

                $('#playerImg').append(badgeSupervisor);
            }
        }
        
        $('#levelImg').css('background-color', '#' + user.level.color );

        if(!showHelpModal){
            showHelpModal = false
        }

        if(showHelpModal){
            let tabs = new Tabs();
            baseController.tabAction(tabs.HELP_TAB);
        }

        //esto evita los desajustes aleatorios de los botones
        $('.round-button').css('vertical-align','top');

        if (world.num_categories > 10) {
            api.getCategoriesInfo(this.drawKnowdelegeList.bind(this))
        }

    };

    drawKnowdelegeList(response){
        for (let i = 0; i < response?.result?.categories_user?.length; i++) {
            let category = response.result.categories_user[i].category;
            category.progressPercent = Math.floor(parseFloat(category.progress)*100);
        }
        
        var template=Handlebars.compile($("#knowdelegeFragment").html());
        $('#knowdelegeSpinner').remove();
        $("#kwnodelegeList").html(template(response?.result?.categories_user));
        $("#kwnodelegeList").height($("#kwnodelegeList").parent().height());

        $('#kwnodelegeList').find('.my-knowledge-list-element-progress').each((i, elem) => {
            var progress = parseInt($(elem).attr('data-progress'));
            createProgressChart($(elem), progress);
        });

        if (!detectmob()) {
            // console.trace('not detectmob');
            // $("#kwnodelegeList").niceScroll();
        }

        let height = 40;

        if ($(window).width() <= 420) {
            height = 30;
        }

        $('.my-knowledge-list-element-name').dotdotdot({
            height: height,
            watch: 'true',
            truncate: 'letter'
        });

    }

    adjustHeight() {

        const windowHeight = $(window).height();
        const headerHeight = $('#appHeader').height() ?? 72;
        const playButtonsHeight = $('.play-buttons').outerHeight();
        const homeInfoBoxes = $('#homeInfoBoxesContainer').find('table');
        const homeInfoBoxesHeight = windowHeight - headerHeight - playButtonsHeight;

        homeInfoBoxes.height(homeInfoBoxesHeight);

    }

    static showSupervisorAccessDeniedAlert() {

        swal({
            title: "",
            text: Translator.trans('TR_ESTE_USUARIO_NO_PUEDE_JUGAR_A_ESTE_JUEGO'),
            type: "warning",
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "",
            closeOnConfirm: true
        }, function(){
            // onConfirm
        });

    }

    static showWorldClosedAlert() {

        swal({
            title: "",
            text: world.message_time,//sprintf(Translator.trans('TR_EL_JUEGO_ESTA_DISPONIBLE_DESDE_HASTA'), world.start_time, world.end_time),
            type: "warning",
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "",
            closeOnConfirm: true
        }, function(){
            // onConfirm
        });

    }

}